export const downloadPreSignedURL = (s3Url) => {
  const handleDownload = async () => {
    try {
      const a = document.createElement('a');
      a.href = s3Url;
      a.download = 'archivo_s3';
      document.body.appendChild(a);
      a.click();

      a.remove();
      globalThis.URL.revokeObjectURL(s3Url);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };
  handleDownload();
};
